import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
})

const collectionResponseHandler = async response =>
  Promise.resolve({
    data: response.data,
    raw: response
  })

const singularResponseHandler = async response =>
  Promise.resolve({
    data: response.data,
    raw: response
  })

const generalErrorHandler = error => {
  console.error(`[${process.env.REACT_APP_NAME}] ApiService ${error}`)

  return Promise.reject({
    errStatus: error.response.status,
    errData: error.response.data,
    errRaw: error
  })
}

const apiService = {
  request(method, resource, params, config) {
    const tenant = params?.language
    const { language, ...restParams } = params || {}

    let url = resource

    if (!resource.startsWith('http')) {
      url = tenant
        ? `/${tenant}/archicad/${resource.replace(/^\/+/, '')}`
        : `/${resource.replace(/^\/+/, '')}`
    }

    return api
    .request({
      method,
      url,
      params: restParams,
      ...config
    })
    .catch(generalErrorHandler)
  },

  get(resource, slug = '', params) {
    const tenant = params?.language;
    const { language, ...restParams } = params || {};
    const url = tenant
      ? `/${tenant}/archicad/${resource}${slug ? `/${slug}` : ''}`
      : `/${resource}${slug ? `/${slug}` : ''}`;

    return api
      .request({
        method: 'get',
        url: url,
        params: restParams
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler)
  },
  query(resource, params) {
    return api
      .request({
        method: 'get',
        url: `${resource}`,
        params
      })
      .then(collectionResponseHandler)
      .catch(generalErrorHandler)
  },
  save(resource, data, params) {
    return api
      .request({
        method: 'post',
        url: `${resource}`,
        data,
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler)
  },
  update(resource, slug = '', data, params) {
    return api
      .request({
        method: 'put',
        url: `${resource}/${slug}`,
        data,
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler)
  },
  patch(resource, slug = '', data, params) {
    return api
      .request({
        method: 'patch',
        url: `${resource}/${slug}`,
        data,
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler)
  },
  delete(resource, slug = '') {
    return api
      .request({
        method: 'delete',
        url: `${resource}/${slug}`
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler)
  },
  upload(resource, slug = '', file, type, params) {
    return api
      .request({
        method: 'post',
        url: `${resource}/${slug}`,
        data: file,
        headers: {
          'Content-Type': type
        },
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler)
  }
}

export default apiService
